<template>
    <div class="learned">
        <div class="container content">
            <div class="row">
                <div class="col-lg-6 col-md-8">
                    <h2 class="little-title toUpperCase color-white f-w-700">segue a gente!</h2>
                    <h2 class="big-title color-white f-w-700">Fique por <br class="show-mobile"> dentro <br class="show-desktop"> das <br class="show-mobile"> novidades</h2>
                    <div class="social-media">
                        <div class="flex f-wrap">
                            <div class="face flex">
                                <div class="img">
                                    <a class="f-w-700" target="_blank" href="https://www.facebook.com/opontofacil">
                                        <img class="img-responsive" src="@/assets/home/icons/icon-face.png" alt="icon-face">    
                                    </a>
                                </div>    
                                <div class="link v-a-in-middle">
                                    <a class="f-w-700" target="_blank" href="https://www.facebook.com/opontofacil">/opontofacil</a>
                                </div>
                            </div>
                            <div class="insta flex show-desktop">
                                <div class="img">
                                    <a class="f-w-700" target="_blank" href="https://www.instagram.com/opontofacil">
                                        <img class="img-responsive" src="@/assets/home/icons/icon-insta.png" alt="icon-insta">     
                                    </a>
                                </div>
                                <div class="link v-a-in-middle">
                                    <a class="f-w-700" target="_blank" href="https://www.instagram.com/opontofacil">/opontofacil</a>
                                </div>
                            </div>
                        </div>
                        <div class="insta flex show-mobile">
                            <div class="img">
                                <a class="f-w-700" target="_blank" href="https://www.instagram.com/opontofacil">
                                    <img class="img-responsive" src="@/assets/home/icons/icon-insta.png" alt="icon-insta">     
                                </a>
                            </div>
                            <div class="link v-a-in-middle">
                                <a class="f-w-700" target="_blank" href="https://www.instagram.com/opontofacil">/opontofacil</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 flex j-c-center public-op show-desktop">
                    <div>
                        <public-opinion :wid="'500px'" :hei="'200px'" :font_size_p="'13px'" :padd="'0 50px'"/>
                    </div>
                </div>
                <div class="col-md-6 flex j-c-center public-op show-mobile">
                    <div>
                        <public-opinion :wid="'300px'" :hei="'250px'" :font_size_p="'13px'" :padd="'0 50px'"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

    .learned{
        background-color: #357EB8;
    }

    .content{
        padding: 100px 0
    }

    .content h2:nth-child(2){
        padding: 0 0 25px 0;
    }

    .social-media{
        padding: 30px 0 0 0;
    }

    a{
        color: #fff;
        margin-left: 10px;
        font-size: 12px
    }

    .insta{
        margin-left: -150px;
    }

    img{
        width: 50px
    }
    small{
        color: #F38235;
        font-size: 10px;
    }
    
     @media only screen and (max-width: 767px){
        .learned .content{
            margin-left: 50px;
            padding: 75px 0 50px 0;
        }

        .insta{
            margin-left: 0;
            margin-top: 25px;
        }

        .public-op{
            margin-top: 50px;
        }

        img{
            width: 60px;
        }
        a
        {
            font-size: 16px;
        }
    }
    

    
</style>

<script>
import PublicOpinion from '@/components/PublicOpinion.vue'
    export default {
        data() {
            return{

            }
        },

        components:{
            PublicOpinion
        }
        
    }
</script>